import React from "react";

import { viewBoardingPagePermissionSet } from "helpers";
import { getInstallationAppLink } from "mappers";
import { useInstallationSearchQuery } from "queries";

import { installationResultItem } from "../resultItems";

import { ReactComponent as InstallationQueueIcon } from "static/images/installation_queue_search.svg";

const installationSection = () => {
	return {
		name: "installationQueueRequest",
		title: "Installation Queue",
		useSearchQuery: useInstallationSearchQuery,
		renderItem: installationResultItem,
		getIcon: () => <InstallationQueueIcon />,
		getLink: ({ application_status, id }) =>
			getInstallationAppLink(application_status, id),
		requiredPermissions: viewBoardingPagePermissionSet,
	};
};

export default installationSection;
